import { gql, ApolloError } from 'apollo-boost';
import { Room } from '../../types/api';
import { useState, useEffect } from 'react';
import { useQuery } from '@apollo/react-hooks';

const GET_ROOM_QUERY = gql`
  query Room($code: String!) {
    room(code: $code) {
      id
      muteParticipants
      chef {
        id
        name
      }
    }
  }
`;

export default function useRoomByCodeQuery(
  roomCode: string
): { loading: boolean; room: Room | null; error?: ApolloError } {
  const [room, setRoom] = useState<Room | null>(null);

  const { loading, data, error } = useQuery<{ room: Room }>(GET_ROOM_QUERY, {
    variables: { code: roomCode },
    skip: !roomCode,
  });

  useEffect(() => {
    setRoom(data?.room || null);
  }, [data]);

  return { loading, room, error };
}
